const numberOrNull = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

export const getOkrInlineDetails = (result = {}) => {
    const sourceDetails = result.sourceDetails || {};
    const metricKey = result.sourceMetricKey || sourceDetails.metricKey;
    const presentDetails = (details) => details
        .map((detail) => ({ ...detail, value: numberOrNull(detail.value) }))
        .filter((detail) => detail.value !== null);

    if (metricKey === 'routeCompliancePercentage' || metricKey === 'routeComplianceAndParLevel') {
        return presentDetails([
            { label: 'Route compliance', value: sourceDetails.routeCompliancePercentage, suffix: '%' },
            { label: 'Avg. Par Level', value: sourceDetails.avgParLevelPercentage, suffix: '%' },
            { label: 'Active routes', value: sourceDetails.activeRoutes },
            { label: 'Unserviced machines KPI', value: sourceDetails.unattendedCount ?? sourceDetails.unservicedMachineDays }
        ]);
    }

    if (metricKey === 'preventiveCompletionPerRoute' || metricKey === 'preventiveCompletionCount') {
        return presentDetails([
            { label: 'Completed preventives', value: sourceDetails.completedPreventives ?? sourceDetails.preventiveCompletionCount },
            { label: 'Routes included', value: sourceDetails.routeCount },
            { label: 'Average per route', value: sourceDetails.averagePerRoute },
            { label: 'Target per route', value: sourceDetails.targetPerRoute }
        ]);
    }

    if (metricKey === 'ticketsPer10Machines') {
        return presentDetails([
            { label: 'Tickets included', value: sourceDetails.ticketCount },
            { label: 'Assigned machines', value: sourceDetails.assignedMachineCount },
            { label: 'Tickets per 10 machines', value: sourceDetails.ticketsPer10Machines },
            { label: 'OKR source percentage', value: sourceDetails.scorePercentage, suffix: '%' }
        ]);
    }

    if (sourceDetails.actualValue !== undefined || result.actualValue !== undefined) {
        return presentDetails([
            { label: 'Actual value', value: sourceDetails.actualValue ?? result.actualValue }
        ]);
    }

    return [];
};

export const getCompletedPreventivesFromOkrResults = (results = [], fallback = 0) => {
    const preventiveResult = results.find((result) =>
        result?.sourceMetricKey === 'preventiveCompletionPerRoute' ||
        result?.sourceMetricKey === 'preventiveCompletionCount'
    );
    const sourceDetails = preventiveResult?.sourceDetails || {};
    const value = sourceDetails.completedPreventives ?? sourceDetails.preventiveCompletionCount;
    const parsed = numberOrNull(value);
    if (parsed !== null) return parsed;

    return numberOrNull(fallback) ?? 0;
};
